var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evaluate"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topBanner"},[_c('p',[_vm._v("欢迎使用")]),_c('strong',[_vm._v("中文出版物知识产权评价系统")])])
}]

export { render, staticRenderFns }